import React from 'react'
import { observer } from 'mobx-react'
import api from 'api'
import dynamic from 'next/dynamic'
import getConfig from 'next/config'
import * as R from 'ramda'
import { COUPON_PLATFORM } from 'constants/coupon'
import Head from 'next/head'

const SkuDetailContents = {
  app01webview: dynamic(() => import('/components/SkuDetail')),
  generalWeb: dynamic(() => import('/components/SkuDetailV2')),
}
const skuPlatform = {
  app01webview: COUPON_PLATFORM.HK01_APP,
  generalWeb: COUPON_PLATFORM.COUPON_WEB,
}
const Sku = observer((props) => {
  const { publicRuntimeConfig } = getConfig()
  const SkuDetail = SkuDetailContents[publicRuntimeConfig.SERVICE_SEGMENT]
  const name = props?.sku?.name

  return (
    <>
      <Head>
        <title>{name || '01優惠券 | 香港01'}</title>
      </Head>
      <SkuDetail {...props} />
    </>
  )
})

const getSkuDetailData = async (skuIdOrHashId) => {
  let result = {}
  const { publicRuntimeConfig } = getConfig()
  try {
    result = await api.getSku(skuIdOrHashId, {
      platform: skuPlatform[publicRuntimeConfig.SERVICE_SEGMENT],
    })
  } catch (err) {
    result = R.path(['response', 'data', 'error'], err)
  }
  const { data: sku, code: errCode } = result
  return {
    sku,
    error: errCode ? result : null,
  }
}

Sku.getInitialProps = async (props) => {
  const { pathname, query, asPath, req = {} } = props
  const { featureFlags, query: urlQuery } = req
  const { id: skuIdOrHashId = '', merchantIdList = [], fast: fastShare } = query
  const defaultResponse = {
    skuIdOrHashId,
    asPath,
    pathname,
    query,
    urlQuery,
    isFullPage: true,
    fastShare,
    shouldTrackEnabled: true,
  }

  if (
    skuIdOrHashId.startsWith(' ') ||
    (/^\d+$/.test(skuIdOrHashId) && featureFlags && !featureFlags.accessBySkuId)
  ) {
    return {
      ...defaultResponse,
      error: {
        code: '10111',
      },
    }
  }

  const { sku, error } = await getSkuDetailData(skuIdOrHashId)
  return {
    ...defaultResponse,
    sku,
    error,
    // highTrafficModeEnable default false if sku is invalid
    // error handled in SkuDetailV2
    highTrafficModeEnable: sku
      ? R.includes(sku.merchant.id.toString(), merchantIdList)
      : false,
  }
}

export default Sku
